{
    "MakeCallTitle": "Fazer ligação",
    "MakeCallTooltip": "Faça uma chamada para o dispositivo correspondente.",
    "IttTitle": "Transferência de consulta",
    "IttTooltip": "Faça uma chamada de consulta de consulta para o dispositivo correspondente para iniciar uma operação de transferência de chamada.",
    "CallDetailsTitle": "Detalhes da chamada...",
    "CallDetailsTooltip": "Apresentar informações detalhadas da chamada numa nova janela.",
    "CompleteTransferTitle": "Transferência completa",
    "CompleteTransferTooltip": "Conclua a operação de transferência de chamada de consulta iniciada anteriormente movendo a chamada em espera para o destino de destino chamado anteriormente.",
    "PickupThisCallTitle": "Capturar esta chamada",
    "PickupThisCallTooltip": "Atenda esta chamada de alerta imediatamente na sua extensão.",
    "StealThisCallTitle": "Roubar esta chamada",
    "StealThisCallTooltip": "Mova a chamada atualmente atendida ou em alerta para a sua extensão, onde irá depois tocar.",
    "SendToCallTitle": "Enviar chamada para...",
    "SendToCallTooltip": "Mova a chamada atualmente atendida ou em alerta para um novo destino específico onde ela tocará posteriormente.",
    "MonitorTitle": "Monitorizar",
    "MonitorTooltip": "Opções de monitorização de dispositivo e chamadas.",
    "SilentMonitorTitle": "Monitorização Silenciosa",
    "SilentMonitorTooltip": "Inicie uma sessão de monitorização silenciosa com a chamada atualmente atendida no dispositivo.",
    "ForcedIntrudeTitle": "Entrada Forçada",
    "ForcedIntrudeTooltip": "Entrar (intercetar) a chamada atualmente atendida no dispositivo correspondente, para que possa participar ativamente dessa chamada.",
    "RecordCallTitle": "Gravar chamada",
    "RecordCallTooltip": "Execute uma operação de gravação de chamadas ao vivo na chamada atendida de momento no dispositivo.",
    "RegisterCallbackTitle": "Registar devolução de chamada",
    "RegisterCallbackTooltip": "Apresentar uma mensagem no dispositivo correspondente, lembrando-os de ligar de volta para a sua extensão específica.",
    "AgentSignInOutTitle": "Entrada\/saída do agente",
    "AgentSignInOutTooltip": "Entrar\/sair da extensão.",
    "SignInTitle": "Entrar...",
    "SignInTitleAllGroups": "Entrar (todos os grupos)",
    "SignInTooltip": "Conecte o dispositivo ou agente correspondente, tornando-o 'de serviço' e potencialmente disponível para atender chamadas ACD.",
    "SignOutTitle": "Sair",
    "SignOutTitleAllGroups": "Sair (todos os grupos)",
    "SignOutTooltip": "Desconecte o dispositivo ou agente correspondente, tornando-os 'fora de serviço' e indisponíveis para atender chamadas ACD.",
    "GroupsTitle": "Grupos",
    "GroupsTooltip": "Escolha em quais grupos de ACDs este agente está com sessão iniciada.",
    "NoGroupsTooltip": "Nenhum Grupo ACD foi encontrado para este Agente.",
    "GroupsAllTitle": "[All]",
    "SetDndOnTitle": "Ativar DND (Não Incomodar)",
    "SetDndOnTooltip": "Ative o Não Incomodar no dispositivo, o que o tornará indisponível para receber chamadas.",
    "SetDndOffTitle": "Desligar DND (Não Incomodar)",
    "SetDndOffTooltip": "Desative o Não Incomodar no dispositivo, o que o tornará disponível para receber chamadas de entrada.",
    "SetStatusTitle": "Definir estado",
    "SetStatusTooltip": "Defina o estado de ACD para este agente.",
    "AvailableTitle": "Disponível",
    "AvailableTooltip": "Defina o agente para o estado Disponível, que o tornará disponível para atender chamadas ACD.",
    "DndTitle": "ND",
    "DndTooltip": "Defina o agente para o estado DND (Não Incomodar), o que o tornará indisponível para atender chamadas ACD.",
    "WrapUpTitle": "Wrap-up",
    "WrapUpTooltip": "Defina o agente no estado de Wrap-up, o que o tornará indisponível para atender chamadas ACD.",
    "NotAvailableTitle": "Indisponível",
    "NotAvailableTooltip": "Defina o agente no estado ACD Indisponível e especifique adicionalmente um código de motivo, que pode ser usado para identificar por que o agente correspondente está especificamente indisponível para atender chamadas ACD.",
    "NoReasonTitle": "[Sem motivo]",
    "NoReasonTooltip": "Defina o agente no estado ACD Não Disponível sem fornecer motivo.",
    "AdvancedTooltip": "Ações avançadas de controlo de chamadas.",
    "AnswerCallTitle": "Atender chamada",
    "AnswerCallTooltip": "Atenda a chamada em alerta de momento.",
    "ClearCallTitle": "Limpar chamada",
    "ClearCallTooltip": "Encerre a chamada correspondente.",
    "AdminOnlyTitle": "Apenas administrador",
    "AdminOnlyTooltip": "Ações apenas do administrador.",
    "DeletePhantomTitle": "remover chamada fantasma",
    "DeletePhantomTooltip": "Forçar a aplicação a parar de modelar a chamada correspondente como ativa, o que pode afetar negativamente as estatísticas da chamada.",
    "RowOptions_AdvancedTitle": "Avançado",
    "NAME": "RowOptions",
    "SetAccountCodeMenuOptionTitle": "Definir código de conta",
    "SetAccountCodeMenuOptionTooltip": "Definir o código de conta para esta chamada.",
    "NoAccountCodeMenuOptionTitle": "[Sem código de conta].",
    "NoAccountCodeMenuOptionTooltip": "Anular o código de conta",
    "AccountCodeMenuOptionTooltip": "Definir o código de conta \"{}\" para a chamada."
}